import * as PIXI from "pixi.js";
import Vector from "../../util/vector";

export default class PhotoL {
    constructor(i, resource) {
        this.resource = resource;
        this.index = i;
        this.grid = window.innerWidth <= 768 ? 3 : 10;
        this.size = this.setSize();
        this.mass = 1;
        this.originalPosition = null;
        this.position = this.setPosition(i);
        this.velocity = this.setVelocity();
        this.acceleration = new Vector(0, 0);
        this.g = new PIXI.Container();
        this.appearV = 0.05;
        this.g.alpha = this.setInitialAlpha();

        this.init();
    }

    setInitialAlpha() {
        return this.index;
    }

    init() {
        this.factory();
    }

    arrayShuffle([...array]) {
        for (let i = array.length - 1; i >= 0; i--) {
            const j = Math.floor(Math.random() * (i + 1));
            [array[i], array[j]] = [array[j], array[i]];
        }
        return array;
    }

    setPosition(i) {
        //倍角画像なので、どこかに乗せるようにする
        //縦方向の重なりはアニメーション上不利になるので、やめる
        const limit = Math.floor((window.innerHeight * window.devicePixelRatio) / this.size.height);
        const row = i % limit;
        this.row = row;

        const point = [i, row * 2];
        let x = ((window.innerWidth * window.devicePixelRatio) / this.grid) * point[0];
        let y = (this.size.height / 2) * point[1];

        //スマホのときは位置を決め打ちする
        if (window.innerWidth <= 768) {
            const locale = [
                { x: 0, y: 0, row: 0 },
                { x: 2, y: 2, row: 3 },
                { x: 1, y: 4, row: 5 },
                { x: 0, y: 6, row: 7 },
                { x: 2, y: 8, row: 9 },
            ];

            x = locale[i] ? (locale[i].x * this.size.width) / 2 : (locale[0].x * this.size.width) / 2;
            y = locale[i] ? (locale[i].y * this.size.height) / 2 : (locale[0].y * this.size.height) / 2;
        }

        //console.log(x, y);

        return new Vector(x, y);
    }

    setSize() {
        //サイズを分割数に合わせる
        const w = ((window.innerWidth * window.devicePixelRatio) / this.grid) * 2;
        const h = w / 1.777;

        return { width: w, height: h };
    }

    setVelocity() {
        const x = this.row % 2 == 0 ? 0.5 : -0.5;
        return new Vector(x, 0);
    }

    randLimit(min, max) {
        return Math.random() * (max - min) + min;
    }

    applyForce(force) {
        const f = force.divide(this.mass);
        this.acceleration = this.acceleration.add(f);
    }

    update(t) {
        this.velocity = this.velocity.add(this.acceleration);
        this.position = this.position.add(this.velocity);

        if (!this.appear) {
            this.g.alpha += this.appearV;
        }

        if (this.g.alpha >= 1) {
            this.appear = true;
        }

        if (this.position.x < -this.size.width) {
            this.position.x = (this.size.width / 2) * this.grid;
        } else if (this.position.x > (this.size.width / 2) * this.grid) {
            this.position.x = -this.size.width;
        }
    }

    remap() {
        this.size = this.setSize();
        this.position = this.setPosition(this.index);
        this.g.width = this.size.width;
        this.g.height = this.size.height;
    }

    factory() {
        const names = Object.keys(this.resource.sprite.textures);
        const s_names = this.arrayShuffle(names);
        //const s_names = names;
        const number = this.index % names.length;
        const sprite = new PIXI.Sprite.from(s_names[number]);
        this.g.addChild(sprite);
        this.g.width = this.size.width;
        this.g.height = this.size.height;
    }

    display() {
        this.g.position.x = this.position.x;
        this.g.position.y = this.position.y;
    }
}
